export default __webpack_public_path__ + "static/media/email.f064b00a.svg";